module.exports = __webpack_public_path__ + "static/media/AppLogo_Background.ca00a932.png";